export const STATUS_CODE = {
  SUCCESS: 200,
  UNAUTHORIZED: 403,
  ERROR: 500,
};

export const STATUS_CODE_TEXT = {
  SUCCESS: "OK",
  ERROR: "KO",
};

export const ALLOWED_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  OPTIONS: "OPTIONS",
};

export const DEFAULT_LANGUAGE = "it";

export const MESSAGE_GENERIC_ERROR = {
  it: "Si è verificato un errore.\nTi invitiamo a riprovare in seguito.",
  en: "Something went wrong.\nRetry later",
};
